import { useEnv } from '~/env'
import { getFragmentData } from '~/lib/graphql'
import { planName } from '~/lib/plan/name'
import { PcShareButton } from '../PcShareButton'
import type { SharePlanProps } from '../SharePlanFragment'
import { SharePlanFragment } from '../SharePlanFragment'

export function SharePlanButton({ plan: data }: SharePlanProps) {
  const {
    planId,
    course,
    additionalContents,
    restrictions,
    restaurant: { restaurantId, name: restaurantName },
  } = getFragmentData(SharePlanFragment, data)
  const { RESTAURANT_IKYU_ORIGIN } = useEnv()

  const fullPlanName = planName({ course, additionalContents, restrictions })
  const planUrl = `${RESTAURANT_IKYU_ORIGIN}/${restaurantId}/plan${planId}`

  return (
    <PcShareButton type="プラン" title={restaurantName} description={fullPlanName} url={planUrl} />
  )
}
